<div *ngIf="isPageReady" class="flex flex-col h-full w-full">
  <h4 class="mb-4">Allocation of Purchase Orders</h4>

  <p-panel header="Main Purchase Order" class="w-full mb-4">
    <div class="grid grid-cols-7 gap-4">
      <div class="col-span-1">P/O: <span class="text-lg font-bold">{{parentPurchaseOrder.purchaseOrder}}</span></div>
      <div>Start Date: <span class="font-bold">{{parentPurchaseOrder.startDate | date:'shortDate'}}</span></div>
      <div>End Date: <span class="font-bold">{{parentPurchaseOrder.endDate | date:'shortDate'}}</span></div>
      <div class="col-span-2">Current Balance: <span class="font-bold">{{parentPurchaseOrder.amt | currency}}</span></div>
      <div class="col-span-2 p-2 border-2 text-lg font-bold text-primary">
        Adjusted Balance: <span class="font-bold">{{adjustedAmt() | currency}}</span>
      </div>
    </div>
  </p-panel>

  <div class="grow mb-4">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="allocationDetail"></prox-ag-grid>
  </div>

  <div class="flex pt-2 items-center">
    <p-button (onClick)="onOk()" label="Save" icon="pi pi-check" styleClass="mr-2"></p-button>
    <p-button (onClick)="onCancel()" label="Cancel" icon="pi pi-times" styleClass="mr-2"></p-button>
  </div>
</div>
